// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_gT","advertDetailContactItem__link":"c-m_gU","advertDetailContactItem__stub":"c-m_gV"};